<template>
  <div class="merchant-layout">
    <div id="titleDiv">
      <h2 id="titleH2">The Merchant of</h2>
      <h1 id="titleH1">Yonder</h1>
    </div>

    <h2 id="yourH2">Your AURA tokens: {{ auraBalance }}</h2>

    <v-row id="layoutRow">
      <v-col sm="4">
        <MaTicket />
      </v-col>
      <v-col sm="4">
        <MaUserItems />
      </v-col>
      <v-col sm="4">
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Web3 from 'web3';
  import BigNumber from 'bignumber.js';

  import MaTicket from './MaTicket';
  import MaUserItems from './MaUserItems';
  import { toNumberWithThousandSeparator } from '../../utils/general';

  const RealShrineConstants = require('../../constants/realShrine');
  const guruNFTAbi = require("../../constants/abis/guruNFT.json");
  const auraTokenAbi = require("../../constants/abis/auraToken.json");
  const stakingProxyNFTAbi = require("../../constants/abis/stakingProxyNFT.json");

  export default {
    name: 'MyAura',
    components: {
      MaTicket,
      MaUserItems
    },
    data: () => ({
      auraBalance: 0,
      // Contract variables. eros god
      web3: '',
      guruPassNFTContract: '',
      auraContract: '',
      currentAccount: '',
      // WordPress bind data. eros god
      wpData: wpData,
    }),
    mounted() {
      this.initialize();
    },
    methods: {
      async initialize() {
        if (typeof window.ethereum === 'undefined') return;

        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        this.currentAccount = accounts[0];

        const web3js = window.web3;
        if (typeof web3js === 'undefined') return;

        this.web3 = new Web3(web3js.currentProvider);

        this.web3.eth.defaultAccount = this.currentAccount;

        this.guruPassNFTContract = this.web3.eth.contract(guruNFTAbi).at(wpData.GURUPASS_NFT_CONTRACT_ADDRESS);
        this.auraContract = this.web3.eth.contract(auraTokenAbi).at(wpData.AURA_TOKEN_CONTRACT_ADDRESS);

        let _this = this;
        this.auraContract.balanceOf.call(this.currentAccount, function(err, res) {
          if (!err) {
            _this.auraBalance = toNumberWithThousandSeparator(new BigNumber(res).toNumber() / 1000000000000000000);
          } else {
            console.log(err.code);
          }
        });
      }
    },
    computed: {
    },
  };
</script>

<style scoped>
  p, h1, h2 {
    margin: 0px;
  }

  #titleDiv {
    background-image: url(https://dev.mysticgurus.club/wp-content/uploads/2022/02/woodsign.svg);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    text-align: center;
  }
  #titleDiv #titleH2 {
    font-weight: 600;
    text-shadow: 2px 2px 3px rgb(255 255 255 / 50%);
    font-family: Architects Daughter;
    padding-top: 10px;
    color: #333;
  }
  #titleDiv #titleH1 {
    font-weight: 600;
    text-shadow: 2px 2px 3px rgb(255 255 255 / 30%);
    font-family: Architects Daughter;
    color: #333;
  }

  #yourH2 {
    color: white;
    text-align: center;
    font-family: Architects Daughter;
    margin-top: 10px;
  }

  #layoutRow {
    margin-top: 30px;
  }

  @media only screen and (max-width: 1300px) {
    #layoutRow .col-sm-4 {
      min-width: 400px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MyAura/index.vue